import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Filter, ISalRepFilter, EmptySalRepFilter } from "./Filter";
import { SubTable } from "./SubTable";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { format } from "date-fns";

export interface INonPVPerformanceReport {
    login_ID?: number,
    user_Name?: string,
    branchName?: string,
    totalPvAssigned?: number,
    totalConvertedPv?: number,
    conversionRatio?: number,
    conversionPercentage?: number,

}

export const NonPerformingPvReport = (permissions: IPermissionProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<INonPVPerformanceReport>, loading: boolean });
    const [tFooter, setTFooter] = useState<INonPVPerformanceReport>({});
    const [salRepFilter, setSalRepFilter] = useState<ISalRepFilter>(EmptySalRepFilter);
     const [tableLoad, setTableLoad] = useState(false);
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);


    let _role: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _role.push(role.role_ID);
    });


    const [subTable, setSubTable] = useState({ singleData: {}, open: false, salesID: 0, resType: 0 } as { open: boolean, salesID: number, resType: number, singleData: any });
    const hideSubTableDialog = () => {
        setSubTable({ open: false, salesID: 0, resType: 0, singleData: {} });
    };

    useEffect(() => {
        if(tableLoad){
        loadTableData();
        setTableLoad(false)
        }
    }, [salRepFilter]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("NonPerformingPV", "GET", null, `filter=${JSON.stringify(salRepFilter)}`, toast);
        if (response) {
            const data: Array<INonPVPerformanceReport> = await response.json();

            const _data: Array<INonPVPerformanceReport> = [];
            let totalPvAssigned = 0;
            let totalConvertedPv = 0;

            data.forEach((d, i) => {
                if (d.totalPvAssigned) totalPvAssigned += d.totalPvAssigned;
                if (d.totalConvertedPv) totalConvertedPv += d.totalConvertedPv;

                _data.push(d);
            });
            const totalRecords: INonPVPerformanceReport = {
                user_Name: "Total Records",
                totalPvAssigned: totalPvAssigned,
                totalConvertedPv: totalConvertedPv,

            };
            setTFooter(totalRecords);

            setTableData({ tableData: _data, loading: false });
        }
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
            </React.Fragment>
        );
        // const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
        // return (
        //     permissions.is_Export || loginObj.is_Team_Lead ?
        //         <React.Fragment>
        //             <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
        //         </React.Fragment> : ''
        // );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Assigned PV</h5>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
        </div>
    );

    const ftotalPvAssigned = <div style={{ fontWeight: 'bold' }}>{tFooter.totalPvAssigned}</div>
    const ftotalConvertedPv = <div style={{ fontWeight: 'bold' }}>{tFooter.totalConvertedPv}</div>
    const TotalPvAssigned = (rowData: INonPVPerformanceReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 1, singleData: rowData })} className="cursor-pointer text-cyan-700 underline">{rowData.totalPvAssigned}</span>
    const TotalConvertedPv = (rowData: INonPVPerformanceReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 2, singleData: rowData })} className="cursor-pointer text-cyan-700 underline">{rowData.totalConvertedPv}</span>

    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter salRepFilter={salRepFilter} setSalEffFilter={setSalRepFilter} onSearch={() => setTableLoad(true)}  />
                </AccordionTab>
            </Accordion>



            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} footer={tFooter.user_Name} />
                <Column field="user_Name" header="Sales Manager" sortable />
                <Column field="branchName" header="Sales Comp(Branch)" sortable />
                <Column field="totalPvAssigned" header="Assigned PV" sortable body={TotalPvAssigned} footer={ftotalPvAssigned} />
                <Column field="totalConvertedPv" header="Converted" sortable body={TotalConvertedPv} footer={ftotalConvertedPv} />
                <Column field="conversionRatio" header="Convertion(Ratio)" sortable />
                <Column field="conversionPercentage" header="Convertion(%)" sortable />
            </DataTable>
            <SubTable singleData={subTable.singleData} open={subTable.open} salesID={subTable.salesID} resType={subTable.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={salRepFilter} />
            {/* <Filter open={filter} hideDialog={hideFilterDialog} setSalEffFilter={setSalRepFilter} toast={toast} /> */}
            <Toast ref={toast} />
        </>
    );
}
